import { LLBtn2 } from '../../../../components';
import { trans } from '../../../../common/utils';


export const DeleteFavoriteItemModal = ({ deleteItem, type }) => {
    const text = {
        team: 'FAV_REMOVE_TEAM_CONFIRM',
        tournament: 'FAV_REMOVE_TOURNAMENT_CONFIRM',
        market: 'FAV_REMOVE_MARKET_CONFIRM',
    };
    return (
        <>
            <p>
                {trans(text[type] ?? '')}
            </p>
            <LLBtn2 onClick={deleteItem}>{trans('Yes')}</LLBtn2>
        </>
    );
};